// extracted by mini-css-extract-plugin
export var centerText = "_c0-8";
export var container = "_c0-0";
export var doughnutContainer = "_c0-7";
export var legend = "_c0-a";
export var legendItemColorDisplay = "_c0-b";
export var legendItemLabel = "_c0-d";
export var legendItemValue = "_c0-c";
export var lg = "_c0-5";
export var maxWidth = "_c0-9";
export var md = "_c0-4";
export var responsive = "_c0-6";
export var sm = "_c0-3";
export var xs = "_c0-2";
export var xxs = "_c0-1";